
Greenmile.PanelBuilder = Greenmile.PanelBuilder || {};

Greenmile.PanelBuilder.CardEdit = function (clickHandler, editMode) {

    Greenmile.PanelBuilder.Card.apply(this, arguments);

    this.elBackBuilder = document.createElement("div");
    this.elBackBuilder.setAttribute('class', 'Card BackCard BackCardBuild');

    this.elFrontBuilder = document.createElement("div");
    this.elFrontBuilder.setAttribute('class', 'Card FrontalCard');

    this.clickHandler = clickHandler;
    this.editMode = editMode;

    this.fieldList = [];

    this.elCard = document.createElement("div");

    this.cleanFields = function () {
        this.fieldList.forEach(function (cardField) {
            cardField.setValue({ isFront: cardField.isFront, fieldPosition: cardField.fieldPosition });
        });
    };

    this.setValues = function (config) {

        this.cleanFields();

        if (config && config.length) {
            config.forEach(function (cardField) {

                var founded = this.fieldList.reduce(function (returned, builder) {
                    if (builder.isFront === cardField.isFront && builder.fieldPosition === cardField.fieldPosition) {
                        returned = builder;
                    }
                    return returned;
                }, null);

                if (founded) {
                    founded.setValue(cardField);
                }

            }, this);
        }
    };

    this._renderFrontal = function (el, description, routeView) {
        el.innerHTML = "";
        el.appendChild(this.buildDate(routeView));
        el.appendChild(this.getStatus(routeView));
        el.appendChild(description);
    };

    this.renderFrontalBuilder = function () {
        return this.elFrontBuilder;
    };

    this.renderBackBuilder = function () {
        return this.elBackBuilder;
    };

    this.getValue = function () {
        return this.fieldList;
    };

    this.createStructure = function (routeView) {
        let selectContainer = document.createElement('div');
        [1, 2, 3].forEach( (fieldPosition) => {

            var field = {
                elFieldList: document.createElement('div')
            };
            
            if (this.editMode) {
                field = new Greenmile.PanelBuilder.SelectFieldList(`RouteView`);
                field.beforeCreateList = function () {
                    this.reduceToFieldTypes(["TEXT"]);
                };
                field.render();
            }

            this.fieldList.push(new Greenmile.PanelBuilder.CardField({
                isFront: true,
                fieldPosition: fieldPosition,
                clickHandler: this.clickHandler.bind(this),
                field: field
            }));

            selectContainer.appendChild(field.elFieldList);
        });

        this._renderFrontal(this.elFrontBuilder, selectContainer, routeView || {});
        this.elBackBuilder.appendChild(this.getStatus(routeView));

        [1, 2, 3, 4, 5].forEach(function (fieldPosition) {

            var backField = {};
            if (this.editMode) {
                backField = new Greenmile.PanelBuilder.SelectFieldList("RouteView");
                backField.render();
                this.elBackBuilder.appendChild(backField.elFieldList);
            }

            this.fieldList.push(new Greenmile.PanelBuilder.CardField({
                isFront: false,
                fieldPosition: fieldPosition,
                field: backField,
                clickHandler: this.clickHandler
            }));

        }, this);

    };

};